import { render, staticRenderFns } from "./genericModal.vue?vue&type=template&id=da239fbc&scoped=true&"
import script from "./genericModal.vue?vue&type=script&lang=js&"
export * from "./genericModal.vue?vue&type=script&lang=js&"
import style0 from "./genericModal.vue?vue&type=style&index=0&id=da239fbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da239fbc",
  null
  
)

export default component.exports